import { useState } from 'react'
import { Modal } from '../ui/Modal'
import AddCardPaymentForm from './AddCardPaymentForm'

const MercadoPagoPaymentModal = ({
  isOpen,
  onClose,
  amount,
  customerId,
  cardsIds = [],
  onSuccess
}) => {
  const [isProcessing, setIsProcessing] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)

  const handleClose = () => {
    if (isProcessing) return
    setShowSuccessModal(false)
    setIsProcessing(false)
    onClose()
  }

  const handleSuccess = (response) => {
    setShowSuccessModal(true)
    if (onSuccess) {
      onSuccess(response)
    }
  }

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false)
    handleClose()
  }

  return (
    <>
      <Modal isOpen={isOpen && !showSuccessModal && !isProcessing} onClose={handleClose}>
        <AddCardPaymentForm
          amount={amount}
          customerId={customerId}
          cardsIds={cardsIds}
          showSavedCard={Boolean(customerId)}
          onSuccess={handleSuccess}
          onProcessingChange={setIsProcessing}
          onClose={handleClose}
        />
      </Modal>

      {isProcessing && (
        <Modal isOpen={isProcessing} onClose={() => {}}>
          <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
            <div className="flex flex-col items-center text-center">
              <div className="mb-4">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-accent1"></div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Procesando pago
              </h3>
              <p className="text-gray-600">
                Por favor espera mientras validamos tu tarjeta...
              </p>
            </div>
          </div>
        </Modal>
      )}

      <Modal isOpen={showSuccessModal} onClose={handleSuccessModalClose}>
        <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
          <div className="flex flex-col items-center text-center">
            <div className="mb-4">
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100">
                <svg
                  className="h-10 w-10 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              ¡Tarjeta Registrada Exitosamente!
            </h3>
            <p className="text-gray-600 mb-6">
              Tu tarjeta ha sido registrada sin problemas. El cobro de validación de $50 será devuelto automáticamente.
            </p>
            <button
              onClick={handleSuccessModalClose}
              className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-primary-dark transition-colors font-semibold"
            >
              Aceptar
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default MercadoPagoPaymentModal
